var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.pages.login.loginView==='fullscreen')?_c('login-full-screen',{attrs:{"mode":this.eventMode}}):_c('login-boxed',{attrs:{"mode":this.eventMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }